export const name = 'viewerManagerLayoutApi' as const

export const RenderDoneSymbol = Symbol('RenderDone')
export const MeasureMapApiSymbol = Symbol('MeasureMapApi')
export const RegisterLayoutDoneApiSymbol = Symbol('RegisterLayoutDoneApi')
export const ScreenSizeApiSymbol = Symbol('ScreenSizeApi')
export const DomApiSymbol = Symbol('DomApi')
export const ComponentBoundingBoxApiSymbol = Symbol('ComponentBoundingBoxApi')
